import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { messages as AuthMessages } from '../../constants/Anon';
import QA from '../../constants/QATags';
import { getLoginPath, getRegisterPath } from '../../lib/RouteUtils';

import './SignupModalButtons.scss';

const SignupModalButtons = ({ closeModal }) => {
  return (
    <div className='SignupModalButtons__buttons'>
      <Link
        className='SignupModalButtons__signupLink'
        to={getRegisterPath()}
        onClick={closeModal}
        data-qa={QA.SUB}
      >
        {<FormattedMessage {...AuthMessages.signUp} />}
      </Link>
      <div className='SignupModalButtons__bottomText'>
        <FormattedMessage
          {...AuthMessages.hasPandoraAccount}
          values={{
            link: (
              <Link
                className='SignupModalButtons__loginLink'
                to={getLoginPath()}
                onClick={closeModal}
                data-qa={QA.LB}
              >
                {<FormattedMessage {...AuthMessages.login} />}
              </Link>
            ),
          }}
        />
      </div>
    </div>
  );
};

SignupModalButtons.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default SignupModalButtons;
